import React from 'react';
import { SOCIAL_MESSAGE } from '../../brands/default/content/components/registration';

const SocialMessage = () => {
  return (
    <>
      <p className="social-message">{SOCIAL_MESSAGE}</p>
      <style jsx>{`
        .social-message {
          color: #01b901;
          margin-bottom: 2px;
        }
      `}</style>
    </>
  );
};

export default SocialMessage;
